import { toPng } from 'html-to-image'
import { jsPDF } from 'jspdf'

const BROCHURE_WIDTH = 1080
const BROCHURE_HEIGHT = 1620

export async function downloadCatalogPdf(
  element: HTMLElement,
  filename: string
): Promise<void> {
  const dataUrl = await toPng(element, {
    quality: 0.95,
    pixelRatio: 2,
    cacheBust: true,
    skipFonts: false,
    preferredFontFormat: 'woff2',
  })

  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'px',
    format: [BROCHURE_WIDTH, BROCHURE_HEIGHT],
  })

  pdf.addImage(dataUrl, 'PNG', 0, 0, BROCHURE_WIDTH, BROCHURE_HEIGHT)
  pdf.save(filename)
}
